import type { OrganizationContactRole } from "../../../../api/types/userManagementTypes";

export interface OrganizationContactRoleInfo {
  role: OrganizationContactRole;
  description: string;
  maxCount: number;
  allowsExternalEmail: boolean;
}

export const organizationContactRoles: OrganizationContactRoleInfo[] = [
  {
    role: "PrimaryAccountContact",
    description:
      "Receives renewal notices, contract terms, executive escalations, and major service announcements. " +
      "Typically the CFO, COO, or Managing Partner who owns the commercial relationship.",
    maxCount: 2,
    allowsExternalEmail: false,
  },
  {
    role: "AccountManager",
    description:
      "Receives operational updates, training invitations, quarterly business reviews, and product adoption insights. " +
      "Typically a senior fund accountant, controller, or operations lead who uses Entrilia day-to-day.",
    maxCount: 10,
    allowsExternalEmail: false,
  },
  {
    role: "BillingContact",
    description:
      "Receives invoices, payment reminders, subscription notices, and renewal terms. Primary contact appears on invoices. " +
      "Typically AP, accounts payable, or a finance operations lead.",
    maxCount: 10,
    allowsExternalEmail: true,
  },
  {
    role: "SecurityContact",
    description:
      "Receives breach notifications, SOC 2 reports, vulnerability disclosures, and security advisories. " +
      "Typically the CISO, head of IT, or a security distribution list.",
    maxCount: 10,
    allowsExternalEmail: true,
  },
  {
    role: "TechnicalAdmin",
    description:
      "Receives API changes, integration notices, scheduled maintenance windows, and breaking-change announcements. " +
      "Typically the engineer or IT lead who owns SSO and API setup.",
    maxCount: 10,
    allowsExternalEmail: true,
  },
];
